import actionTypes from './ActionTypes';
import apiConf from '../../config/api';
import request from '../../utils/request';
import routerConfig from '../../config/router';

const addPhotoTour = (data) => {
  const url = apiConf.endpoints.genAddPhotoTourUrl();
  return dispatch => {
    return request
      .formData(url, data, dispatch, actionTypes.ADD_PHOTO_TOUR)
      .then((res) => {
        res.data.tourPhotos = res.data.tourPhotos.reverse();
        dispatch({type: actionTypes.ADD_PHOTO_TOUR.fulfilled, data: res.data.tourPhotos});
        return res;
      })
  }
};

/**
 * Create Tour
 * */
const createTour = (data, images, video, history) => {
  const url = apiConf.endpoints.genCreateTourUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.CREATE_TOUR)
      .then((res1) => {
        const urlImg = apiConf.endpoints.genAddPhotoTourUrl();
        return request
          .formData(urlImg, {tour_id: res1.data.tour.id, images}, dispatch, actionTypes.ADD_PHOTO_TOUR)
          .then(() => {
            if (video.name && video.type && video.size) {
              const videoUrl = apiConf.endpoints.genUploadTourVideoUrl();
              request.formData(videoUrl, {tour_id: res1.data.tour.id, video}, dispatch, actionTypes.UPLOAD_TOUR_VIDEO)
                .then(() => {
                  dispatch({type: actionTypes.UPLOAD_TOUR_VIDEO.fulfilled});
                  dispatch({type: actionTypes.CREATE_TOUR.fulfilled});
                  history.push(routerConfig.vendor.home);
                })
            } else {
              dispatch({type: actionTypes.CREATE_TOUR.fulfilled});
              history.push(routerConfig.vendor.home);
            }
          })
      })
  }
};

const getTourList = () => {
  const url = apiConf.endpoints.genGetMyTourListUrl();
  return dispatch => {
    return request
      .get(url, dispatch, actionTypes.GET_TOUR_LIST)
      .then((res) => {
        dispatch({type: actionTypes.GET_TOUR_LIST.fulfilled, data: res.data});
        return res;
      })
  }
};
/**
 * Edit tour
 * */
const getTourById = (id, checkVideo) => {
  const url = `${apiConf.endpoints.genGetMyTourByIdUrl()}/?tour_id=${id}`;
  return dispatch => {
    return request
      .get(url, dispatch, actionTypes.GET_TOUR_BY_ID)
      .then((res) => {
        res.data.tourPhotos = res.data.tourPhotos.reverse();
        dispatch({type: actionTypes.GET_TOUR_BY_ID.fulfilled, data: res.data, checkVideo});
        return res;
      })
  }
};

const changeEditTourData = (data) => {
  return dispatch => {
    dispatch({type: actionTypes.CHANGE_TOUR_DATA, data})
  }
};

const deletePhotoTour = (data) => {
  const url = apiConf.endpoints.genDeletePhotoTourUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.DELETE_PHOTO_TOUR)
      .then((res) => {
        dispatch({type: actionTypes.DELETE_PHOTO_TOUR.fulfilled, data: res.data.tourPhotos});
        return res;
      })
  }
};

const editTour = (data, history) => {
  const url = apiConf.endpoints.genEditTourUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.EDIT_TOUR)
      .then((res) => {
        dispatch({type: actionTypes.EDIT_TOUR.fulfilled});
        history.goBack();
        return res;
      })
  }
};

const uploadVideo = (data) => {
  const url = apiConf.endpoints.genUploadTourVideoUrl();
  return dispatch => {
    return request
      .formData(url, data, dispatch, actionTypes.UPLOAD_TOUR_VIDEO)
      .then((res) => {
        dispatch({type: actionTypes.UPLOAD_TOUR_VIDEO.fulfilled});
        dispatch(getTourById(data.tour_id));
        return res;
      })
  }
};

const deleteVideoTour = (data, cb) => {
  const url = apiConf.endpoints.genDeleteVideoTourUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.DELETE_TOUR_VIDEO)
      .then((res) => {
        dispatch({type: actionTypes.DELETE_TOUR_VIDEO.fulfilled});
        if (typeof cb === 'function')
          cb();
        dispatch(getTourById(data.tour_id));
        return res;
      })
  }
};

const deleteTour = (data) => {
  const url = apiConf.endpoints.genDeleteTourUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.DELETE_TOUR)
      .then((res) => {
        dispatch({type: actionTypes.DELETE_TOUR.fulfilled});
        dispatch(getTourList());
        return res;
      })
  }
};

const closePopup = () => {
  return dispatch => {
    dispatch({type: actionTypes.TOGGLE_SHOW_POPUP})
  }
};

const cleanState = () => {
  return dispatch => {
    dispatch({type: actionTypes.CLEAN_EDIT_TOUR_STATE})
  }
}

export {
  createTour,
  getTourList,
  getTourById,
  changeEditTourData,
  deletePhotoTour,
  addPhotoTour,
  editTour,
  deleteTour,
  uploadVideo,
  deleteVideoTour,
  closePopup,
  cleanState
}


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Action.js